import React from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import PropTypes from "prop-types";
import WorkOrderContractInfoItem from "./WorkOrderContractInfoItem";
import "./WorkOrderContractInfo.css";

function WorkOrderContractInfo({ contractInfo }) {
  const sortedContractInfo = contractInfo.sort((a, b) => {
    if (a.contractType === "Sales Order on NAV") return 1;
    if (b.contractType === "Sales Order on NAV") return -1;
    return 0;
  });

  if (contractInfo === null || contractInfo.length === 0) {
    return (
      <Container className="coreContent mt-4">
        <h3>Contract Information</h3>
        <Row>
          <Col>No contract information is available</Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container className="coreContent mt-4">
      <h3>Contract Information</h3>
      <Row>
        <Col>
          <Accordion defaultActiveKey={sortedContractInfo[0].contractId}>
            {sortedContractInfo.map((item) => (
              <WorkOrderContractInfoItem
                key={item.contractId}
                contractInfoItem={item}
              />
            ))}
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
}

WorkOrderContractInfo.propTypes = {
  contractInfo: PropTypes.arrayOf(
    PropTypes.shape({
      contractId: PropTypes.number,
    })
  ).isRequired,
};

export default WorkOrderContractInfo;
